import { indexTypes } from "@/mocks/evidence";

export default function IndexNav() {
  return (
    <section className="relative bg-background-100">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-3 px-4 py-10 md:grid-cols-2 md:px-6 md:py-12 lg:grid-cols-4">
        {indexTypes.map((t) => {
          const solid =
            t.color === "accent"
              ? "bg-accent-100 text-accent-800"
              : "bg-primary-100 text-primary-700";
          return (
            <a
              key={t.key}
              href="#library"
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${solid}`}
              >
                <i className={`${t.icon} flex h-6 w-6 items-center justify-center text-2xl`} />
              </span>
              <span className="min-w-0">
                <span className="flex items-baseline gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {t.name}
                  </span>
                  <span className="text-xs font-semibold text-foreground-500">
                    {t.count}
                  </span>
                </span>
                <span className="mt-1 block truncate text-xs leading-relaxed text-foreground-600">
                  {t.desc}
                </span>
              </span>
              <i className="ri-arrow-right-line ml-auto flex h-4 w-4 shrink-0 items-center justify-center text-lg text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
            </a>
          );
        })}
      </div>
    </section>
  );
}